import { render, staticRenderFns } from "./FormaPagamentoCadastroModal.vue?vue&type=template&id=025ff55c&scoped=true"
import script from "./FormaPagamentoCadastroModal.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./FormaPagamentoCadastroModal.vue?vue&type=style&index=0&id=025ff55c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025ff55c",
  null
  
)

export default component.exports